import { Modal } from "antd";
import React from "react";

const SupportedBrowserModal = ({ isModalOpen, setIsModalOpen }) => {
    const userAgent = navigator.userAgent || "";
      const isChrome = /Chrome/.test(userAgent) && !/Edge|OPR|Brave/.test(userAgent);
      const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
      const isiOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;


  return (
    <Modal
      title=""
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      className="joinWaitPopupModal"
      wrapClassName="menuStickyPopupModalWrapClassName"
      width={320}
    >
      <div className="menuStickyPopupContainer joinwishListStickyPopupContainer">
        <div className="thankYouJoinlistHeader">{isiOS ? "For Best Experience on iOS" : "Unsupported Browser"}</div>
        <div className="joinwaitPopupContent">
          <div className="joinwaitPopupContentHeader">
          {isiOS
            ? "For a better experience, please open this site in Safari on your iPhone or iPad."
            : "For a better experience, please use Chrome or Safari to access this site."}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SupportedBrowserModal;
